import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { T } from '../styles/theme';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/register', { name, email, password });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.detail || 'Errore durante la registrazione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ maxWidth: 420, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 64, height: 64, background: T.gradPrimary, borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <span style={{ fontFamily: T.fontDisplay, color: 'white', fontWeight: 800, fontSize: '1.5rem' }}>IE</span>
          </div>
          <h1 style={{ fontFamily: T.fontDisplay, fontSize: '2rem', fontWeight: 800, color: T.text }}>Crea Account</h1>
          <p style={{ fontFamily: T.fontBody, color: T.muted, marginTop: 8 }}>Unisciti all'Impero Elite</p>
        </div>

        <form onSubmit={handleSubmit} className="card" style={{ padding: 32 }}>
          {error && (
            <div style={{ background: T.redGlow, border: `1px solid ${T.red}`, borderRadius: 10, padding: '12px 16px', marginBottom: 24, color: T.red, fontFamily: T.fontBody, fontSize: '0.85rem' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: 20 }}>
            <label className="label">Nome</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="input" placeholder="Il tuo nome" />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label className="label">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="input" placeholder="nome@email.com" />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label className="label">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="input" placeholder="••••••••" />
          </div>

          <button type="submit" disabled={loading} className="btn-primary" style={{ width: '100%', padding: 14, justifyContent: 'center', fontSize: '1rem', opacity: loading ? 0.5 : 1 }}>
            {loading ? 'Registrazione...' : 'Registrati'}
          </button>

          <p style={{ fontFamily: T.fontBody, color: T.muted, fontSize: '0.85rem', textAlign: 'center', marginTop: 24 }}>
            Hai già un account?{' '}
            <Link to="/login" style={{ color: T.violet, textDecoration: 'none' }}>Accedi</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
